import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { FeatureToggleOffDirective } from './feature-toggle-off.directive';
import { FeatureToggleOnDirective } from './feature-toggle-on.directive';
import { FeatureToggleService } from './feature-toggle.service';

export function checkFeatureToggles(ftService: FeatureToggleService) {
  return (): Promise<void> => ftService.togglesLoaded();
}

export const FEATURE_TOGGLE_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: checkFeatureToggles,
  deps: [FeatureToggleService],
  multi: true
};

@NgModule({
  declarations: [FeatureToggleOnDirective, FeatureToggleOffDirective],
  imports: [CommonModule],
  exports: [FeatureToggleOnDirective, FeatureToggleOffDirective]
})
export class FeatureToggleModule {}

export * from './feature-toggle-off.directive';
export * from './feature-toggle-on.directive';
export * from './feature-toggle.service';
